import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { ErrorPanel, Page, PageSkeleton } from "@/components/layout/page";
import { ApiError } from "@/lib/api";
import { routeTree } from "./routeTree.gen";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingComponent: PageSkeleton,
  defaultErrorComponent: ({ error, reset }) => (
    <Page>
      <ErrorPanel error={error} reset={reset} />
    </Page>
  ),
  defaultNotFoundComponent: () => (
    <Page>
      <ErrorPanel error={new Error("This page doesn't exist.")} />
    </Page>
  ),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
